import * as React from "react"
import { SVGProps } from "react"
const SvgComponent = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    id="Livello_2"
    width={48}
    height={48}
    data-name="Livello 2"
    {...props}
  >
    <defs>
      <style>{".cls-1{fill:none;stroke:#060b0c;stroke-miterlimit:10}"}</style>
    </defs>
    <g id="Palette">
      <path
        d="m35.27 2.83 9.9 9.9-32.44 32.44-9.9-9.9L35.27 2.83m0-2.83L0 35.27 12.73 48 48 12.73 35.27 0Z"
        style={{
          fill: "#060b0c",
          strokeWidth: 0,
        }}
      />
      <path
        d="m21.88 13.39 6.36 6.37M26.12 9.15l6.37 6.36M30.36 4.91l6.37 6.36M13.39 21.88l6.37 6.36M17.64 17.64 24 24M4.91 30.36l6.36 6.37M9.15 26.12l6.36 6.37"
        className="cls-1"
      />
    </g>
  </svg>
)
export default SvgComponent
